import React, { Component } from 'react';
import { connect } from 'react-redux';
import TransactionsView from './Transactions.view';
import enums from "../../../constants/enums";

export class TransactionsContainer extends Component {

  constructor(props){
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);

    this.submitForm = this.submitForm.bind(this);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.addOrder = this.addOrder.bind(this);
    this.removeOrder = this.removeOrder.bind(this);

    this.state = {
      formState: {
        data: {},
      }
    }
  }

  componentDidMount() {
    this.getTransactions(this.props);
  }

  componentWillReceiveProps(nextProps){
    if(
      this.props.filtersFormState !== nextProps.filtersFormState ||
      this.props.page !== nextProps.page
    ){
      this.getTransactions(nextProps);
    }
  }

  toggleEdit(transaction){
    const { dispatch } = this.props;

    dispatch({
      type: 'TOGGLE_TRANSACTION_EDIT',
    });
    this.setState({
      formState: {
        data: transaction,
      },
    });
  }

  onFormUpdate(formState) {
    this.setState({
      formState,
    });
  }

  submitForm(formState) {
    const { dispatch, filtersFormState, page } = this.props;
    dispatch({
      $global: true,
      type: 'UPDATE_TRANSACTION',
      payload: {
        page,
        filters: filtersFormState && filtersFormState.data,
        data: formState.data
      }
    });
  }

  removeOrder(index){
    const { formState } = this.state;
    const { data } = formState;

    this.setState({
      formState: {
        ...formState,
        data: {
          ...data,
          orders: [
            ...data.orders.slice(0, index),
            ...data.orders.slice(index + 1),
          ]
        }
      }
    });

  }

  addOrder(){
    const { formState } = this.state;
    const { data } = formState;
    this.setState({
      formState: {
        ...formState,
        data: {
          ...data,
          orders: [
            ...data.orders,
            {
              status: enums.orderStatus[0].value,
              orderNumber: '',
            },
          ]
        }
      }
    });
  }

  getTransactions(props){
    const { dispatch, filtersFormState, page } = props;
    dispatch({
      type: 'FETCH_TRANSACTIONS',
      payload: {
        filters: filtersFormState.data,
        page: page,
      }
    });
  }

  nextPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'TRANSACTIONS_NEXT_PAGE',
    });
  }

  previousPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'TRANSACTIONS_PREVIOUS_PAGE',
    });
  }

  onFilterChange(filtersFormState){
    const { dispatch } = this.props;
    dispatch({
      type: 'TRANSACTIONS_FILTERS_CHANGE',
      payload: {
        filtersFormState,
      }
    });
  }

  render() {
    return (<TransactionsView
      onFilterChange={this.onFilterChange}
      nextPage={this.nextPage}
      previousPage={this.previousPage}
      toggleEdit={this.toggleEdit}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
      removeOrder={this.removeOrder}
      addOrder={this.addOrder}
      {...this.props}
      {...this.state}
    />);
  }

}

function mapStateToProps(state) {
  const { transactions } = state;
  return {
    editing: transactions.editing,
    transactions: transactions.transactions,
    filtersFormState: transactions.filtersFormState,
    page: transactions.page,
  };
}

export default connect(mapStateToProps)(TransactionsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Transactions/Transactions.container.js